import type { ErrorMessageType } from "@freightsimple/ui-core/FormLayout/FormItem";
import type { AddContactContactType } from "@/Shared/Types/contactTypes";
import type { ContactErrors } from "@/Shared/Contacts/Validators/contactsErrorMessagesForContact";
import {
  EmailRequired,
  contactsErrorMessagesForContact,
} from "@/Shared/Contacts/Validators/contactsErrorMessagesForContact";
import { locationsErrorMessageForBusinessName } from "@/Shared/Locations/Validators/locationsErrorMessageForBusinessName";
import type { AddressErrors } from "@/Shared/Locations/Validators/locationsErrorMessagesForAddress";
import { locationsErrorMessagesForAddress } from "@/Shared/Locations/Validators/locationsErrorMessagesForAddress";
import type { Broker } from "@freightsimple/generated-dashboard-openapi-client/models/Broker";
import type { PreQuoteLocation } from "@freightsimple/generated-dashboard-openapi-client/models/PreQuoteLocation";
import type { AddBrokerBrokerType } from "@/Shared/Types/brokerTypes";

export interface BrokerErrors {
  businessName: ErrorMessageType;
  accountNumber: ErrorMessageType;
  address: AddressErrors;
  contact: ContactErrors;
}

export function brokersErrorMessagesForBroker(
  broker: AddBrokerBrokerType | Broker,
  comparisonContacts?: Map<string, AddContactContactType>,
  pickupLocation?: PreQuoteLocation,
  deliveryLocation?: PreQuoteLocation,
): BrokerErrors {
  return {
    businessName: locationsErrorMessageForBusinessName(
      broker.businessName,
      pickupLocation,
      deliveryLocation,
    ),
    accountNumber: broker.accountNumber
      ? undefined
      : "Customs broker account number is required",
    address: locationsErrorMessagesForAddress(
      broker.address,
      pickupLocation,
      deliveryLocation,
    ),
    contact: contactsErrorMessagesForContact(
      broker.contact,
      EmailRequired.EmailRequired,
      comparisonContacts,
    ),
  };
}
